const Scheduling = (function () {
  function loadSchedulingLanding() {
    const schedulingCalendarBtn = button.build({
      text: 'NEW! SCHEDULES',
      style: 'secondary',
      type: 'contained',
      callback: function () {
        setActiveModuleSectionAttribute('scheduling-calendar');
        PROGRESS.SPINNER.show('Loading Schedule...');
        SchedulingCalendar.init();
      },
    });
    const schedulingCalendarWeb2CalBtn = button.build({
      text: 'View Calendar',
      style: 'secondary',
      type: 'contained',
      callback: function () {
        setActiveModuleSectionAttribute('scheduling-calendar');
        PROGRESS.SPINNER.show('Loading Schedule...');
        schedulingCalendar.init();
      },
    });
    const schedulingRequestTimeOffBtn = button.build({
      text: 'Request Time Off',
      style: 'secondary',
      type: 'contained',
      callback: function () {
        setActiveModuleSectionAttribute('scheduling-requestTimeOff');
        PROGRESS.SPINNER.show('Loading...');
        schedulingRequestTimeOff.init();
      },
    });
    const schedulingApproveRequestBtn = button.build({
      text: 'Approve Requests',
      style: 'secondary',
      type: 'contained',
      callback: function () {
        setActiveModuleSectionAttribute('scheduling-approveRequests');
        PROGRESS.SPINNER.show('Loading...');
        schedulingApproveRequest.init();
      },
    });

    var btnWrap = document.createElement('div');
    btnWrap.classList.add('landingBtnWrap');

    btnWrap.appendChild(schedulingCalendarBtn);
    btnWrap.appendChild(schedulingCalendarWeb2CalBtn);

    if ($.session.schedulingView === true && $.session.schedulingUpdate === false) {
    } else {
      btnWrap.appendChild(schedulingRequestTimeOffBtn);
      btnWrap.appendChild(schedulingApproveRequestBtn);

      // if (
      //   $.session.schedulingSecurity === true ||
      //   $.session.isASupervisor === true ||
      //   $.session.isALocationSupervisor === true
      // ) {
      //   btnWrap.appendChild(schedulingApproveRequestBtn);
      // }
    }

    DOM.ACTIONCENTER.appendChild(btnWrap);
  }

  function init() {
    if (!$.session.schedulingUpdate) {
      setActiveModuleSectionAttribute('scheduling-calendar');
      SchedulingCalendar.init();
    } else {
      loadSchedulingLanding();
    }
  }

  return {
    init,
  };
})();

// Tickets being worked on, search the comment string to find the spot to feature flag this ticket
// Ticket .#176153 - [UNIT SITE TESTING] icon on group view
// Ticket .#167342 - [UNIT SITE TESTING] shift notes
// Ticket .#171154 - [DEV SITE TESTING] show appointments
// Ticket .#161708 - [DEV SITE TESTING] grouped employee dropdown
// Ticket .#180603 - [DEV IN PROGRESS] work code dropdown
// Ticket .#162055 - [DEV IN PROGRESS] copy shift

$.session.flag = {
  pubUnpubIcon: true, // T.176153
  shiftNote: true, // T.167342
  appointments: false, // T.171154
  employeeDropdown: false, // T.161708
  workCodeDropdown: false, // T.180603 - need to figure out to save single wc vs many wc's
  copyShifts: false, // T.162055
};
